// Recursively extract text content (or alt) from a React node tree.
// Originally adapted from https://stackoverflow.com/questions/50428910
// to also pick up the `alt` attribute on <img>-like elements.
//
// Was previously narrowed via `typeof node === 'object'`, but in React 19
// some object-shaped children (e.g. Promise children, certain fragments,
// portal wrappers) don't expose a `.props` field, which crashed at runtime
// with "Cannot read properties of undefined (reading 'alt')". Using
// `isValidElement` is the supported way to know we have a React element
// with a typed `props` object.

import { isValidElement } from 'react';

const extractText = (node: React.ReactNode): string => {
  if (typeof node === 'string' || typeof node === 'number') {
    return node.toString();
  }
  if (Array.isArray(node)) {
    return node.map(extractText).join('');
  }
  if (isValidElement(node)) {
    const props = node.props as {
      alt?: string;
      children?: React.ReactNode;
    };
    if (props.alt) {
      return props.alt;
    }
    return extractText(props.children);
  }
  return '';
};

export default extractText;
